import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface VersandkostenState extends BasePageState {}
interface VersandkostenModel {}

export default class VersandkostenPage extends Basepage<
  VersandkostenState,
  VersandkostenModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="versandkosten">
        <h1>Porto-Konditionen</h1>
        <table>
          <tbody>
            <tr>
              <th style={{ textAlign: 'left' }}>Produkt</th>
              <th>netto Preis</th>
            </tr>
            {this.body.versand.map((versand: any) => {
              return (
                <tr>
                  <td style={{ textAlign: 'left' }}>{versand.Beschreibung}</td>
                  <td style={{ textAlign: 'right' }}>
                    {parseFloat(versand.kosten).toFixed(2)} €*
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
        <span>
          * Die angegebenen Preise sind netto Preise, sie beinhalten jedoch
          bereits, sofern es anfällt, den Maut- und Energiekostenzuschlag sowie
          den Peakzuschlag im November und Dezember.
          <br />
          Im November und Dezember wird durch DHL ein Peakzuschlag von Höhe von
          19 Cent je Sendung erhoben.
          <br />
          In der Black Week und der Cyber Week vom 24.11. bis zum 7.12. kommt
          ein weiterer Zuschlag in Höhe von 50 Cent on top.
          <br />
          Beide Peak Zuschläge werden aber in die oben gezeigten Kosten
          einkalkuliert, wenn Sie in dem genannten Zeitraum diese Seite
          besuchen.
          <br />
          <br />
          Zu jeder Sendung kommen Handlingkosten in Höhe von 0,75 € hinzu. Die
          Verpackungskosten sind darin bereits enthalten.
          <br />
          Ab dem 1. Januar 2027 beträgt die Handlingsgebühr 0,92 € je Sendung.
          <br />
          <br />
          <b>Die Portokosten werden je Sendung an Sie berechnet.</b> Bitte
          nehmen Sie daher unbedingt noch die Einstellung der Versandtage in
          Ihrem{' '}
          <a href="http://www.buchbutler.de/konto/settings" target="_blank">
            Kundenkonto
          </a>{' '}
          vor.
        </span>
        {/* 
        <b>Versandkosten</b>
        <br />
        <br />
        Für Firmenkunden/Behörden gelten folgende Bedingungen:
        <br />
        <br />
        Artikel, welche mit der Markierung <b>Portofrei</b> gekennzeichnet sind,
        liefern wir Ihnen Versandkostenfrei.
        <br />
        <br />
        <br />
        Für Buchhändler gelten folgende Bedingungen:
        <br />
        <br />
        Die Portokosten unterscheiden sich Variabel bei jedem Artikel.
        <br />
        Der maximale Wert der Portokosten beträgt 3,81 € Netto.
        <br />
        <br />
        Die genannten Preise gelten nur für Lieferungen innerhalb Deutschlands,
        bei Auslandslieferungen können diese von den Angaben abweichen.
        <br />
        Bei Fragen finden Sie unsere Kontaktdaten im Impressum.
        */}
      </div>
    );
  }
  initState(base: BasePageState): VersandkostenState {
    let newState: VersandkostenState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    //$include == "versand"
    return this.state.apiBase + '/Standard.php?include=versandkosten_de';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Versandkosten';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Versandkosten</span>;
  }
  getType(): string {
    return 'VersandkostenPage';
  }
}
